import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Contact } from "./types";
import { useTranslation } from "react-i18next";

interface ContactFormFieldsProps {
  formData: Partial<Contact>;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  disabled?: boolean;
}

export const ContactFormFields = ({
  formData,
  onChange,
  disabled = false
}: ContactFormFieldsProps) => {
  const { t } = useTranslation();
  
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="first_name">{t('contacts.form.firstName')} *</Label>
          <Input
            id="first_name"
            name="first_name"
            value={formData.first_name || ''}
            onChange={onChange}
            placeholder={t('contacts.form.firstNamePlaceholder')}
            required
            disabled={disabled}
          />
        </div>
        
        <div>
          <Label htmlFor="last_name">{t('contacts.form.lastName')}</Label>
          <Input
            id="last_name"
            name="last_name"
            value={formData.last_name || ''}
            onChange={onChange}
            placeholder={t('contacts.form.lastNamePlaceholder')}
            disabled={disabled}
          />
        </div>
      </div>
      
      <div>
        <Label htmlFor="function">{t('candidates.list.function')}</Label>
        <Input
          id="function"
          name="function"
          value={formData.function || ''}
          onChange={onChange}
          placeholder={t('contacts.form.functionPlaceholder')}
          disabled={disabled}
        />
      </div>
      
      <div>
        <Label htmlFor="email">{t('common.email')}</Label>
        <Input
          id="email"
          name="email"
          type="email"
          value={formData.email || ''}
          onChange={onChange}
          placeholder={t('contacts.form.emailPlaceholder')}
          disabled={disabled}
        />
      </div>
      
      <div>
        <Label htmlFor="phone">{t('candidates.profile.phone')}</Label>
        <Input
          id="phone"
          name="phone"
          value={formData.phone || ''}
          onChange={onChange}
          placeholder={t('contacts.form.phonePlaceholder')}
          disabled={disabled}
        />
      </div>
      
      <div>
        <Label htmlFor="notes">{t('companies.info.notes')}</Label>
        <Textarea
          id="notes"
          name="notes"
          value={formData.notes || ''}
          onChange={onChange}
          placeholder={t('contacts.form.notesPlaceholder')}
          rows={3}
          disabled={disabled}
        />
      </div>
    </div>
  );
};
